import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-booking-details-overview',
  templateUrl: './booking-details-overview.component.html',
  styleUrls: ['./booking-details-overview.component.scss']
})
export class BookingDetailsOverviewComponent implements OnInit {
  showloading : boolean  = true;
  showContent = false;
  bookingDetails: any;

  constructor(private router: Router, private storage: StorageService) {}

  ngOnInit() {   
    this.bookingDetails = this.passed_data;
  }

  // Function for navigating to Booking details page
  goToBookingDetails(){
    this.storage.set('km_bk_details',  JSON.stringify(this.bookingDetails)); 
    this.router.navigate(['/booking-details', this.bookingDetails.booking_no ]);
  }

  @Input() passed_data: any;
}
